import { createSelector } from "@reduxjs/toolkit";

import { environmentSelector } from "Reducers/environment";
import { OrderBy } from "Reducers/types";
import { RootState } from "Store/configureStore";

import { convertListToTree } from "./convertListToTree";

export const selectServicesProcesses = (state: RootState) => {
  return state.serviceProcesses;
};

export const selectServicesProcessesWithChildren = createSelector(
  selectServicesProcesses,
  serviceProcesses =>
    serviceProcesses.data.map(serviceProcess => ({
      ...serviceProcess,
      pid: serviceProcess.pid,
      parent_pid: serviceProcess.parent_pid,
      children_number: serviceProcesses.data.filter(
        serviceProcessB => serviceProcessB.parent_pid === serviceProcess.pid
      ).length
    }))
);

type ServiceProcessFilters = { orderBy: OrderBy<string>; search: string };

export const selectServicesProcessesFiltered = createSelector(
  selectServicesProcessesWithChildren,
  (_: unknown, filters: ServiceProcessFilters) => filters,
  (serviceProcesses, { orderBy, search }) => {
    const sortField = orderBy.field;
    const sortDirection = orderBy.direction;

    const sortedResults = serviceProcesses.slice().sort((a, b) => {
      if (a[sortField] < b[sortField]) return sortDirection;
      if (a[sortField] > b[sortField]) return -sortDirection;
      return 0;
    });

    const searchText = search.trim().toLocaleLowerCase();
    if (!searchText) return sortedResults;

    const searchResults = sortedResults.filter(
      serviceProcess =>
        serviceProcess.pid.toString().includes(searchText) ||
        serviceProcess.name.toLocaleLowerCase().includes(searchText) ||
        serviceProcess.username.toLocaleLowerCase().includes(searchText)
    );

    return searchResults;
  }
);

export const selectServicesProcessesAsTree = createSelector(
  selectServicesProcessesFiltered,
  serviceProcesses => convertListToTree(serviceProcesses)
);

export const selectServicesProcessesModal = createSelector(
  selectServicesProcesses,
  serviceProcesses => serviceProcesses.modal
);

export const selectAdminAgentUrl = createSelector(
  environmentSelector,
  (_: unknown, params) => params,
  (environment: any, params: any) => {
    const { appName } = params;
    const links = environment?.data?._links?.["#admin-agent"];

    return links?.find((link: any) =>
      link?.href?.endsWith(`/services/${appName}`)
    )?.href;
  }
);
